import { Injectable } from '@angular/core';
import { Grower } from '../interfaces/grower';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/compat/database';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GrowerCrudService {

  
  refs: AngularFireList<any> | undefined;
  ref: AngularFireObject<any> | undefined;

  path: string;

  constructor(private db: AngularFireDatabase) {
    this.path = environment.name + '/settings/growers/' ;
  }

  // Create Grower
  add(record: Grower) {
    this.refs = this.db.list( this.path );
    const item = {
      ...record
    }
    this.refs?.push( item );
  }
  // Fetch Single Grower Object
  get(id: string) {
    this.ref = this.db.object( this.path + id);
    return this.ref;
  }
  // Fetch Growers List
  getList() {
    this.refs = this.db.list( this.path );
    return this.refs;
  }
  // Update Grower Object
  update(record: Grower) {
    this.ref = this.db.object( this.path + record.$key);
   // console.log("P inside", record);
    let item : Partial<Grower>  = {
      ...record
    }
    delete item?.$key;
    this.ref?.update(item);
  }
  // Delete Grower Object
  delete(id: string) {
    this.ref = this.db.object( this.path + id);
    this.ref.remove();
  }
}
